import { render, staticRenderFns } from "./PlatformStatusIndicator.vue?vue&type=template&id=7bb56320&scoped=true"
import script from "./PlatformStatusIndicator.vue?vue&type=script&lang=ts"
export * from "./PlatformStatusIndicator.vue?vue&type=script&lang=ts"
import style0 from "./PlatformStatusIndicator.vue?vue&type=style&index=0&id=7bb56320&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb56320",
  null
  
)

export default component.exports